import {notificationCenter} from './notificationCenter/NotificationCenter';
import {loader} from './loader/Loader';
import Vue from "vue";


document.addEventListener('DOMContentLoaded', (event) => {
  notificationCenter.init();
  loader.init();
});




// WEBPACK FOOTER //
// ./src/global/entry.js